import utils from '@/util/index.js'; // global utils
import store from '../store';

/*
 *  @dec    防抖 单位时间只触发最后一次
 *  @param {String}   type   - 当前元素类型
 *  @param {Function} fn     - 执行事件
 *  @param {String}   event  - 事件类型 例："keydown"
 *  @param {Number}   time   - 间隔时间
 *  @param {Array}    binding.value - [fn,event,time,type]
 *  例：<el-input v-debounce="[queryList,`keydown`,300,'input']" />
 **/
const debounce = {
    inserted: function(el, binding) {
        let [fn, event = 'keydown', time = 500, type = 'input'] = binding.value;
        const targetEl = el.getElementsByTagName(type)[0] || el;
        let timer = null;
        targetEl.addEventListener(event, () => {
            timer && clearTimeout(timer);
            timer = setTimeout(() => fn(targetEl?.value), time);
        });
    },
};
/*
 *  @dec    滚动翻页
 *  @param {String}   type   - 当前元素类型
 *  @param {Number}   time   - 间隔时间
 *  例：<el-table v-loadmore="loadMore">
 **/
const loadmore = {
    inserted: function(el, binding) {
        let selectWrap = el;
        // 判定的是否为表格
        if (el.className.indexOf('el-table') !== -1) {
            selectWrap = el.querySelector('.el-table__body-wrapper');
        }
        const time = 100;
        selectWrap.addEventListener(
            'scroll',
            utils.throttle(function() {
                let sign = 1;
                const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight;
                if (scrollDistance <= sign) {
                    binding.value();
                }
            }, time)
        );
    },
};

import './waves.css';

/*
 * @dec      水波纹效果
 * 使用方法  v-waves
 * 例：<el-button type="primary" v-waves>123</el-button>
 * */
const waves = {
    bind(el, binding) {
        el.addEventListener(
            'click',
            e => {
                const customOpts = Object.assign({}, binding.value);

                // checkbox radio  水波纹点为中心点
                let dom = el,
                    domType = 'hit',
                    canShow = false,
                    overTime = 1,
                    leftNum = 0;
                if (el.className.includes('el-checkbox')) {
                    dom = el.querySelector('.el-checkbox__input');
                    domType = 'center';
                    canShow = true;
                } else if (el.className.includes('el-radio')) {
                    dom = el.querySelector('.el-radio__input');
                    domType = 'center';
                    canShow = true;
                } else if (el.className.includes('el-switch')) {
                    domType = 'center';
                    canShow = true;
                    overTime = 100;
                } else if (el.className.includes('language_change')) {
                    domType = 'center';
                    canShow = true;
                }

                const opts = Object.assign(
                    {
                        ele: dom, // 波纹作用元素
                        type: domType, // hit点击位置扩散center中心点扩展
                        color: 'rgba(0, 0, 0, 0.15)', // 波纹颜色
                    },
                    customOpts
                );

                const target = opts.ele;
                setTimeout(() => {
                    if (target) {
                        target.style.position = 'relative';
                        target.style.overflow = canShow ? '' : 'hidden';
                        const rect = target.getBoundingClientRect();
                        let ripple = target.querySelector('.waves-ripple');
                        if (!ripple) {
                            ripple = document.createElement('span');
                            ripple.className = 'waves-ripple';
                            ripple.style.height = ripple.style.width =
                                Math.max(rect.width, rect.height) + 'px';
                            target.appendChild(ripple);
                        } else {
                            ripple.className = 'waves-ripple';
                        }
                        switch (opts.type) {
                            case 'center':
                                if (
                                    el.className.includes('el-switch') &&
                                    el.className.includes('is-checked')
                                ) {
                                    leftNum = rect.width / 2;
                                } else if (
                                    el.className.includes('el-switch') &&
                                    !el.className.includes('is-checked')
                                ) {
                                    leftNum = '-' + rect.width / 2;
                                }
                                ripple.style.top = rect.height / 2 - ripple.offsetHeight / 2 + 'px';
                                ripple.style.left = leftNum
                                    ? leftNum + 'px'
                                    : rect.width / 2 - ripple.offsetWidth / 2 + 'px';
                                break;
                            default:
                                ripple.style.top =
                                    e.pageY -
                                    rect.top -
                                    ripple.offsetHeight / 2 -
                                    document.body.scrollTop +
                                    'px';
                                ripple.style.left =
                                    e.pageX -
                                    rect.left -
                                    ripple.offsetWidth / 2 -
                                    document.body.scrollLeft +
                                    'px';
                        }
                        ripple.style.backgroundColor = opts.color;
                        ripple.className = 'waves-ripple z-active';
                        return false;
                    }
                }, overTime);
            },
            false
        );
    },
};
/*
 *  @dec    input 聚焦
 *  使用方法  v-focus
 **/
const focus = {
    // 指令的定义
    inserted: function(el) {
        // 聚焦元素
        el.querySelector('input').focus();
    },
};

const filterSpecialChar = {
    update: function(el, { value, modifiers }, vnode) {
        let elNode = el.querySelector('input');
        try {
            if (!vnode.data.model.value) {
                return false;
            }
            let pattern = new RegExp(
                "[`~!@#$%^&*()=|{}':;',\\[\\]<>/?·！…（）—\\-+｜《》？：“”【】、；‘’，￥]"
            );
            if (pattern.test(elNode.value)) {
                elNode.value = vnode.data.model.value.replace(pattern, '');
                console.log('请勿输入特殊字符');
            }
            elNode.dispatchEvent(new Event(modifiers.lazy ? 'change' : 'input'));
        } catch (e) {}
    },
};

const filterPhone = {
    update: function(el, { value, modifiers }, vnode) {
        let elNode = el.querySelector('input');
        let defaultMaxlength = 11;
        try {
            if (!vnode.data.model.value) {
                return false;
            }
            let pattern = new RegExp('[.]');
            if (pattern.test(elNode.value)) {
                elNode.value = vnode.data.model.value.replace(pattern, '');
                console.log('请勿输入特殊字符');
            }
            elNode.value = elNode.value.substring(0, defaultMaxlength);
            elNode.dispatchEvent(new Event(modifiers.lazy ? 'change' : 'input'));
        } catch (e) {}
    },
};
/**
 *  按钮权限
 *  使用方法 v-hasPermission=['xx'] , xx为权限名称
 * */

const hasPermission = {
    bind(el, binding) {
        if (binding.value?.length) {
            let [path] = binding.value;
            const index = store.state.authButtons.findIndex(item => item.route === path);
            // console.log(store.state,index, 'index');
            if (index > -1) return;
            if (el.parentNode) {
                el.parentNode.removeChild(el);
            } else {
                el.innerHTML = '';
                el.style.display = 'none';
            }
        } else {
            if (el.parentNode) {
                el.parentNode.removeChild(el);
            } else {
                el.innerHTML = '';
            }
        }
    },
};
export { debounce, loadmore, waves, focus, filterSpecialChar, filterPhone, hasPermission };
